/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DocumentStatus = {
    PendingUpload: 'pending_upload',
    Processing: 'processing',
    Ready: 'ready',
    Accepted: 'accepted',
    Rejected: 'rejected',
    Abandoned: 'abandoned',
} as const;
export type DocumentStatus = typeof DocumentStatus[keyof typeof DocumentStatus];


export function instanceOfDocumentStatus(value: any): boolean {
    for (const key in DocumentStatus) {
        if (Object.prototype.hasOwnProperty.call(DocumentStatus, key)) {
            if (DocumentStatus[key as keyof typeof DocumentStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DocumentStatusFromJSON(json: any): DocumentStatus {
    return DocumentStatusFromJSONTyped(json, false);
}

export function DocumentStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentStatus {
    return json as DocumentStatus;
}

export function DocumentStatusToJSON(value?: DocumentStatus | null): any {
    return value as any;
}

export function DocumentStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): DocumentStatus {
    return value as DocumentStatus;
}

